import { GiftGroup } from "../../types";

const giftItemIdsByPosCache = new Map<string, string[]>();

export const getShownGiftItemIdsByPosId = (
  giftGroupsByPosId: Record<
    string,
    { shownGiftGroupsById?: Record<string, GiftGroup> }
  >,
  posEntityId?: string
): string[] => {
  if (!posEntityId) return [];

  const cacheKey = `${posEntityId}-${JSON.stringify(
    giftGroupsByPosId[posEntityId]
  )}`;
  if (giftItemIdsByPosCache.has(cacheKey)) {
    return giftItemIdsByPosCache.get(cacheKey)!;
  }

  const posGiftGroups = giftGroupsByPosId[posEntityId];
  if (!posGiftGroups?.shownGiftGroupsById) return [];

  const itemIdSet = new Set<string>();

  Object.values(posGiftGroups.shownGiftGroupsById).forEach((group) => {
    if (group?.items) {
      group.items.forEach((item) => {
        if (item?.id) itemIdSet.add(item.id);
      });
    }
  });

  const result = Array.from(itemIdSet);
  giftItemIdsByPosCache.set(cacheKey, result);
  return result;
};
